enum SPINNER_MODE {
  DEFAULT = "DEFAULT",
  BUTTERFLY = "BUTTERFLY",
  VERBS = "VERBS",
}

export default SPINNER_MODE;
